import { Link } from "react-router-dom";
import './CaseStudy.css';

function CaseStudyCard({ study, index }) {
  return (
    <div className={`gallery-story-card ${index % 2 === 0 ? "" : "reverse"}`}>
      <div className="gallery-story-image">
        <img src={study.image} alt={study.title} />
      </div>

      <div className="gallery-story-content">
        <h3>{study.title}</h3>
        <p>{study.summary}</p>

        <div className="gallery-story-stats">
          {study.stats.map((stat, index) => (
            <div key={index} className="gallery-stat">
              <span className="gallery-stat-value">{stat.value}</span>
              <span className="gallery-stat-label">{stat.label}</span>
            </div>
          ))}
        </div>

        <Link to={`/case-study/${study.url}`}>
          <button className="gallery-btn-case-study">
            View Full Case Study
          </button>
        </Link>
      </div>
    </div>
  );
}

export default CaseStudyCard;